'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import * as React from 'react'

// walrus
import Page, { contentMaxWidth } from '@components/kit/page'
import Box from '@components/kit/box'
import Button from '@components/kit/button'
import Screen from '@components/kit/screen'
import Section from '@components/kit/section'
import Text from '@components/kit/text'
import { CheckMarkPulseIcon } from '@components/kit/icons'

// lib
import { useAuthStore } from '@store/Auth'

/* -----------------------------------------------------------------------------
 * PasswordResetSuccess
 * -------------------------------------------------------------------------- */

const PasswordResetSuccess = () => {
  // flipper signed every device out with the old password, this one included,
  // so all that is left is the local session
  const returnToLogin = () => {
    useAuthStore.getState().clearAllZustandStores()
  }

  return (
    <Screen bg='white' justifyContent='center' alignItems='center'>
      <Page flex={{ mobile: '1 1 auto', tablet: '0 0 auto' }}>
        <Section
          maxWidth={contentMaxWidth}
          flex='1 1 auto'
          justifyContent='space-between'
        >
          <Box
            flex='1'
            alignItems='center'
            mt={{ mobile: '64', tablet: '00' }}
            mx='32'
            mb='32'
          >
            <CheckMarkPulseIcon mt={{ mobile: '64', tablet: '00' }} />
            <Text variant='h1' textAlign='center' mt='24'>
              Your password has been reset
            </Text>
            <Text textAlign='center' mt='08'>
              Log in again with your new password.
            </Text>
          </Box>
          <Button onPress={returnToLogin}>Log in</Button>
        </Section>
      </Page>
    </Screen>
  )
}

export default PasswordResetSuccess
